import React, { useEffect } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import AddLevelForm from '../../../component/levelComps/AddLevelForm';

const AddLevel = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoryHeirarchy());
  }, []);

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Add Level3Category" buttonText="Save"/>
      <AddLevelForm />
    </div>
  );

};

export default AddLevel;
